import axios from "axios"
import Dinero from "dinero.js";
import moment from "moment";

export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}
export function formatNumber(amount, factor = Math.pow(10, 2)) {
  return  Dinero({ amount: Math.round(amount * factor), currency: 'INR' }).setLocale("hi").toFormat("0,0.00");
  //return  Dinero({ amount: Math.round(amount * factor), currency: 'INR', precision: 3 }).setLocale("hi").toFormat("$0,0.00"); for Rs symbol
  //return (a).toLocaleString('hi');
}
export function formatDate(value, dateFormat) {
  if (!value) return "Not Found";
  return moment(String(value)).format(dateFormat);
}

export function getPermissions(url, menuPath) {
  const permission = {
    isAdd: false,
    isEdit: false,
    isDelete: false,
    isDownload: false,
  };
  axios({
    url: url,
    data: {to : menuPath},
    method: "POST",
  })
    .then(function (res) {
      if (res.data)
      {
      res.data.permissions.map(function (value) {
        if (value === "Add") permission.isAdd = true;
        else if (value === "Edit") permission.isEdit = true;
        else if (value === "Delete") permission.isDelete = true;
        else if (value === "Download") permission.isDownload = true;
      });
    }
    })
    .catch(function (err) {
      console.log(err);
    });
    return permission;

  }
